/*
 * General custom scripts
 */
import { Footer } from './front/components/Footer';
new Footer();

/*
 * StretchedLink
 */
import { StretchedLink } from './front/StretchedLink';
new StretchedLink( '.b-image-card' );
new StretchedLink( '.b-blog-box' );
new StretchedLink( '.b-icon-card' );

/*
 * Product gallery lightbox
 */
import { ProductGalleryLightbox } from './front/components/ProductGalleryLightbox';
new ProductGalleryLightbox( '.product-gallery' );
